import React from 'react';
import { Text } from '@mantine/core';
import {
  SECTION_LAYOUT_PRESETS,
  isSectionLayoutCustom,
  presetFullMainSpans,
  sectionMatchesLayoutPreset,
} from '../../utils/proposalSectionPresets';
import LayoutPreview from '../../components/LayoutPreview';
import styles from './SectionLayoutPresetPicker.module.css';
import { GRID_COLUMNS } from '../../utils/proposalSectionColumns';

/** Une définition de préréglage → colonnes de `LayoutPreview`. */
function presetColumns(def) {
  if (def.row) {
    return [{
      weight: GRID_COLUMNS,
      rows: [def.row.map((span) => ({ weight: span }))],
    }];
  }
  const mainSpans = presetFullMainSpans(def);
  return def.mains.map((rows, mainIdx) => ({
    weight: mainSpans[mainIdx],
    rows: rows.map((spans) => spans.map((span) => ({ weight: span }))),
  }));
}

/**
 * Galerie de dispositions de section : aperçus cliquables (grille 12 col).
 * Tuile « Personnalisé » en fin de galerie : sélectionnée quand la config ne
 * matche aucun preset ; sinon cliquable seulement si une config personnalisée
 * a été mémorisée (restauration via onRestoreCustom).
 */
export default function SectionLayoutPresetPicker({
  resolved,
  onSelect,
  hasSavedCustom = false,
  onRestoreCustom,
}) {
  const isCustom = isSectionLayoutCustom(resolved);
  const customDisabled = !isCustom && !hasSavedCustom;
  return (
    <div className={styles.grid} role="listbox" aria-label="Disposition de la section">
      {SECTION_LAYOUT_PRESETS.map((def) => {
        const selected = sectionMatchesLayoutPreset(resolved, def);
        return (
          <button
            key={def.key}
            type="button"
            role="option"
            aria-selected={selected}
            title={def.label}
            className={`${styles.card} ${selected ? styles.cardSelected : ''}`}
            onClick={() => onSelect(def)}
          >
            <LayoutPreview columns={presetColumns(def)} selected={selected} />
            <Text size="10px" c={selected ? 'editor.7' : 'dimmed'} lh={1.2} ta="center">
              {def.label}
            </Text>
          </button>
        );
      })}
      <button
        key="custom"
        type="button"
        role="option"
        aria-selected={isCustom}
        title="Personnalisé"
        disabled={customDisabled}
        className={`${styles.card} ${isCustom ? styles.cardSelected : ''} ${customDisabled ? styles.cardDisabled : ''}`}
        onClick={() => {
          if (isCustom || !onRestoreCustom) return;
          onRestoreCustom();
        }}
      >
        <LayoutPreview
          columns={[{ weight: GRID_COLUMNS, rows: [[{ weight: GRID_COLUMNS, content: '?' }]] }]}
          selected={isCustom}
        />
        <Text size="10px" c={isCustom ? 'editor.7' : 'dimmed'} lh={1.2} ta="center">
          Personnalisé
        </Text>
      </button>
    </div>
  );
}
